import { render, staticRenderFns } from "./HealthCoachingHome.vue?vue&type=template&id=7b22ef3e"
import script from "./HealthCoachingHome.vue?vue&type=script&lang=js"
export * from "./HealthCoachingHome.vue?vue&type=script&lang=js"
import style0 from "./HealthCoachingHome.vue?vue&type=style&index=0&id=7b22ef3e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports